import React from 'react'
import { Columns, Column } from '@resurs/midas-react'
import Page from '../Page'

const PageWrapper = ({ noPadding, ...props }) => (
  <Columns>
    <Column col1 colMd0 noPadding={noPadding} />
    <Column col10 colMd12 noPadding={noPadding}>
      <Page {...props} />
    </Column>
  </Columns>
)

export default PageWrapper
